import { AppState } from '../../bootstrap/redux/state/AppState';

export function selectAssetListItems(state: AppState) {
  return state.assetList.items;
}
